import React, {Component} from 'react';
import {connect} from "react-redux";
import ToastMessage from './ToastMessage';

/*
* Props:
*   toasts: Array of toasts
*     toastType: error, warning, success, info(default)
*     title: Toast title
*     message: Toast message
*/

class Toast extends Component {
    render() {
        return (
            <div className="toast-list-container">
                {this.props.toasts && this.props.toasts.map((toast, index) => (
                    <ToastMessage key={index} toast={toast}/>
                ))}
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        toasts: state.toasts
    };
}

export default connect(mapStateToProps)(Toast);
